export default __webpack_public_path__ + "static/media/youtube.097a5ca8.jpeg";